import { useState, useRef } from "react";
import { DateRange } from "react-date-range";
import type { RangeKeyDict, Range } from "react-date-range";
import { de } from "date-fns/locale";

type FilterDateRangeProps = {
    onRangeSelected: (start: Date, end: Date) => void;
    onClose: () => void;
};

export function FilterDateRange({ onRangeSelected, onClose }: FilterDateRangeProps) {
    const wrapperRef = useRef<HTMLDivElement>(null);

    const [range, setRange] = useState<Range[]>([
        {
            startDate: undefined,
            endDate: undefined,
            key: "selection",
        },
    ]);
    const [hasStartSelected, setHasStartSelected] = useState(false);

    const handleSelect = (ranges: RangeKeyDict) => {
        const { startDate, endDate } = ranges.selection;

        // Wenn Start gewählt, aber End noch nicht (gleicher Tag)
        if (!hasStartSelected) {
            setHasStartSelected(true);
            setRange([ranges.selection]);
            return;
        }

        // Wenn zweiter Klick, also echtes Enddatum gewählt
        if (startDate && endDate && startDate.getTime() !== endDate.getTime()) {
            setRange([ranges.selection]);
            onRangeSelected(startDate, endDate);
            setHasStartSelected(false);
            onClose();
        }
    };

    return (
        <div className="ais-filterDateRange__picker ais-panel" ref={wrapperRef}>
            <DateRange
                editableDateInputs
                locale={de}
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                ranges={range}
                rangeColors={["#0074D9"]}
                dateDisplayFormat="dd.MM.yyyy"
                monthDisplayFormat="MMMM yyyy"
                startDatePlaceholder="Von"
                endDatePlaceholder="Bis"
            />
        </div>
    );
}
